<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import { arch } from "os";
import Swal from "sweetalert2";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Agregar usuarios",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            usuarios:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "age",
            sortDesc: false,
            fields: [
                { key: "nombre", label:'Nombre',sortable: true },
                { key: "apellidoPaterno", label:'Apellido Paterno',sortable: true },
                { key: "apellidoMaterno", label:'Apellido Materno',sortable: true },
                { key: "rut", label:'Rut',sortable: true },
                { key: "email", label:'Email',sortable: true },
                { key: "rol_id", label:'Rol',sortable: true },
                { key: "cargo_id", label:'Cargo',sortable: true },
                { key: "acciones", label:'',sortable: true },
            ],
            usuario:{
                nombre:'',
                email:'',
                apellidoPaterno:'',
                apellidoMaterno:'',
                rut:'',
            },
            archivo:[],
            colegios:[],
        };
    },
    computed: {
    /**
     * Total no. of records
     */
        rows() {
            return this.usuarios.length;
        }
    },
    mounted() {
    // Set the initial number of items
        this.totalRows = this.items.length;
    },
    created() {
        this.actualizar();
    },
    methods: {
    /**
     * Search the table data with search input
     */
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        actualizar(){
            axios.get('/api/get_usuarios').then(res=>{
                this.usuarios = res.data.usuarios;
                this.user.rol_id==1?console.log(this.usuarios):''
                this.usuario={//reinicia variables despues de crear usuarios
                    nombre:'',
                    email:'',
                    apellidoPaterno:'',
                    apellidoMaterno:'',
                    rut:'',
                }
            });
            axios.get('/api/get_colegios').then(res=>{
                this.colegios = res.data.colegios;
            });
            
        },
        crear_usuario(){
            axios.post('/api/crear_usuario', this.usuario).then(res=>{
                if(res.data.estado){
                    //this.$toasted.success(res.data.mensaje);
                    console.log('creado')
                    this.actualizar();
                    this.$bvModal.hide('modal_usuario')
                    Swal.fire({
                        title: "Se ha creado el usuario", 
                        //text: "Debe tomar conocimiento sobre los Documentos Institucionales y Reglamentos",
                        icon: "success",
                        confirmButtonColor: "#f1b44c",
                        confirmButtonText: "Aceptar"
                    });
                    
                }else{
                    //this.$toasted.error(res.data.mensaje);
                    console.log(res.data.mensaje)
                    Swal.fire({
                        title: "Error al crear el usuario", 
                        //text: "Debe tomar conocimiento sobre los Documentos Institucionales y Reglamentos",
                        icon: "error",
                        confirmButtonColor: "#f1b44c",
                        confirmButtonText: "Aceptar"
                    });
                    console.log(res.data.e)
                }
            });
        },
        editar_usuario_modal(item){
            this.usuario=item
            this.usuario.rut=item.rut+'-'+item.rut_dv
            this.$bvModal.show('modal_usuario_editar')
        },
        editar_usuario(){
            axios.post('/api/editar_usuario', this.usuario).then(res=>{
                if(res.data.estado){
                    //this.$toasted.success(res.data.mensaje);
                    console.log('Editado')
                    this.actualizar();
                    this.$bvModal.hide('modal_usuario_editar')
                    Swal.fire({
                        title: "Se ha editado el usuario correctamente", 
                        //text: "Debe tomar conocimiento sobre los Documentos Institucionales y Reglamentos",
                        icon: "success",
                        confirmButtonColor: "#f1b44c",
                        confirmButtonText: "Aceptar"
                    });
                    
                }else{
                    //this.$toasted.error(res.data.mensaje);
                    Swal.fire({
                        title: "Error al editar el usuario", 
                        //text: "Debe tomar conocimiento sobre los Documentos Institucionales y Reglamentos",
                        icon: "error",
                        confirmButtonColor: "#f1b44c",
                        confirmButtonText: "Aceptar"
                    });
                    console.log(res.data.mensaje)
                    console.log(res.data.e)
                }
            });
        },
        cargar_archivo(archivo){
            let formData = new FormData();
            formData.append('archivo', archivo);
            axios.post(`/api/cargar_archivo_usuarios`,formData).then(res => {
                if(res.data.estado){
                    console.log(res.data.mensaje);
                    Swal.fire({
                        title: res.data.mensaje, 
                        text: res.data.repetidas,
                        icon: "success",
                        confirmButtonColor: "#f1b44c",
                        confirmButtonText: "Aceptar"
                    });
                    console.log(res.data.repetidas);
                    this.actualizar();
                }else{
                    console.log(res.data.mensaje);
                    Swal.fire({
                        title: "Error al cargar el archivo", 
                        //text: "Debe tomar conocimiento sobre los Documentos Institucionales y Reglamentos",
                        icon: "error",
                        confirmButtonColor: "#f1b44c",
                        confirmButtonText: "Aceptar"
                    });
                    this.actualizar();
                }
            });
        }
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <b-button class="float-right" variant="primary" v-b-modal.modal-importar>Importar</b-button>
                                <b-modal id="modal-importar" title="Importar usuarios" ok-title="Importar" cancel-title="Cancelar" @ok="cargar_archivo(archivo)">
                                    <b-form-group id="example">
                                        <b-form-file
                                        v-model="archivo"
                                        accept=".csv"
                                        placeholder="Elegir Archivo"
                                        drop-placeholder="Arrastrar archivo..."
                                        browse-text="Examinar"
                                        ></b-form-file>
                                    </b-form-group>
                                    <!-- <b-button class="float-right" variant="primary" @click="cargar_archivo(archivo)">Importar</b-button> -->
                                </b-modal>
                                <b-button class="float-right" variant="primary" v-b-modal.modal_usuario>Nuevo usuario</b-button>
                                <b-modal id="modal_usuario" title="Crear Nuevo Usuario" ok-title="Crear" cancel-title="Cancelar" @ok="crear_usuario">
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Nombre" label-for="text">
                                        <b-form-input for="text" v-model="usuario.nombre"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Apellido Paterno" label-for="text">
                                        <b-form-input for="text" v-model="usuario.apellidoPaterno"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Apellido Materno" label-for="text">
                                        <b-form-input for="text" v-model="usuario.apellidoMaterno"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Rut" label-for="text">
                                        <b-form-input for="text" v-model="usuario.rut"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Email" label-for="text">
                                        <b-form-input for="text" v-model="usuario.email"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Colegio" label-for="text">
                                        <select class="custom-select" v-model="usuario.colegio_id">
                                            <option disabled value="">Seleccione colegio</option>
                                            <option v-for="colegio in colegios" :key="colegio.id" :value="colegio.id">{{colegio.nombre.toUpperCase()}} ({{colegio.comuna_nombre}} - {{colegio.region_nombre}})</option>
                                        </select>
                                    </b-form-group>
                                    <!-- <b-button class="float-right" variant="success" 
                                        @click="crear_usuario" 
                                        :disabled="
                                            usuario.nombre=='' || 
                                            usuario.email=='' || 
                                            usuario.apellidoPaterno=='' || 
                                            usuario.apellidoMaterno=='' || 
                                            usuario.rut==''
                                            " 
                                        >
                                        Crear
                                    </b-button> -->
                                </b-modal>
                                <b-modal id="modal_usuario_editar" title="Editar Usuario" ok-title="Editar" cancel-title="Cancelar" @ok="editar_usuario">
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Nombre" label-for="text">
                                        <b-form-input for="text" v-model="usuario.nombre"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Apellido Paterno" label-for="text">
                                        <b-form-input for="text" v-model="usuario.apellidoPaterno"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Apellido Materno" label-for="text">
                                        <b-form-input for="text" v-model="usuario.apellidoMaterno"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Rut" label-for="text">
                                        <b-form-input for="text" v-model="usuario.rut"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Email" label-for="text">
                                        <b-form-input for="text" v-model="usuario.email"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Colegio" label-for="text">
                                        <select class="custom-select" v-model="usuario.colegio_id">
                                            <option disabled value="">Seleccione colegio</option>
                                            <option v-for="colegio in colegios" :key="colegio.id" :value="colegio.id">{{colegio.nombre.toUpperCase()}} ({{colegio.comuna_nombre}} - {{colegio.region_nombre}})</option>
                                        </select>
                                    </b-form-group>
                                    <!-- <b-button class="float-right" variant="success" 
                                        @click="editar_usuario" 
                                        :disabled="
                                            usuario.nombre=='' || 
                                            usuario.email=='' || 
                                            usuario.apellidoPaterno=='' || 
                                            usuario.apellidoMaterno=='' || 
                                            usuario.rut==''
                                            " 
                                        >
                                        Editar
                                    </b-button> -->
                                </b-modal>
                            </div>
                        </div>
                        <!-- <h4 class="card-title">Data Table</h4> -->
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;usuarios
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filter"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table :items="usuarios" :fields="fields" responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered" >
                                <template v-slot:cell(n)="data">
                                    <p>{{ data.index+1 }}</p>
                                </template>
                                <template v-slot:cell(rut)="data">
                                    <p>{{ data.item.rut }}-{{data.item.rut_dv}}</p>
                                </template>
                                <template v-slot:cell(rol_id)="data">
                                    <p>{{ data.item.rol_nombre }}</p>
                                </template>
                                <template v-slot:cell(cargo_id)="data">
                                    <p>{{ data.item.cargo_nombre }}</p>
                                </template>
                                <template v-slot:cell(acciones)="data">
                                    <b-button size="sm" variant="primary" @click="editar_usuario_modal(data.item)">Editar</b-button>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>